/**
 * config/endpoints.js — every backend path in ONE place.
 *
 * Keeping paths centralized means a backend route change is a one-line edit here,
 * never a hunt through api.js. Each entry is a function returning a path string
 * (relative to CONFIG.API_BASE_URL). Path params are arguments; query params are
 * passed separately to the http layer.
 *
 * ES module. Import:  import ENDPOINTS from "../config/endpoints.js";
 */

export const ENDPOINTS = {
  auth: {
    login: () => `/auth/login`,
    register: () => `/auth/register`,
    oauth: (provider) => `/auth/oauth/${provider}`, // provider: "google" | "kakao"
    logout: () => `/auth/logout`,
    me: () => `/auth/me`,
    refresh: () => `/auth/refresh`,
  },

  images: {
    list: () => `/images`,                                // ?sort=&tag=&q=&cursor=&limit=
    get: (id) => `/images/${id}`,
    similar: (id) => `/images/${id}/similar`,
    like: (id) => `/images/${id}/like`,                   // POST like / DELETE unlike
    save: (id) => `/images/${id}/save`,                   // POST save / DELETE unsave
    download: (id) => `/images/${id}/download`,           // ?resolution=hi|std
    file: (id) => `/images/${id}/file`,                   // ?resolution=hi|std
    variations: (id) => `/images/${id}/variations`,       // POST → new variation set
    remove: (id) => `/images/${id}`,                      // DELETE (owner or admin soft delete)
  },

  generations: {
    create: () => `/generations`,                         // POST params → job
    get: (id) => `/generations/${id}`,                    // GET status + results
  },

  users: {
    me: () => `/users/me`,
    profile: (handle) => `/users/${handle}`,
    works: () => `/users/me/works`,                       // ?type=created|saved|liked&cursor=&limit=
    credits: () => `/users/me/credits`,
    follow: (handle) => `/users/${handle}/follow`,        // POST follow / DELETE unfollow
  },

  apiKeys: {
    list: () => `/users/me/api-keys`,
    create: () => `/users/me/api-keys`,                   // POST { name } → { ..., key } (1회만 노출)
    revoke: (id) => `/users/me/api-keys/${id}`,           // DELETE
  },

  catalog: {
    tags: () => `/catalog/tags`,
    styles: () => `/catalog/styles`,
    models: () => `/catalog/models`,
    palettes: () => `/catalog/palettes`,
    all: () => `/catalog`,                                // convenience: everything at once
  },
};

export default ENDPOINTS;
